import { SiteCodes } from './siteCodes'

const SHORT_BRAND_NAME_JAYCAR = 'Jaycar'
const SHORT_BRAND_NAME_RTM = 'RTM'
const FULL_BRAND_NAME_JAYCAR = 'Jaycar Electronics'
const FULL_BRAND_NAME_RTM = 'Road Tech Marine'

export enum BrandCode {
  Jaycar = 'jc',
  RTM = 'rtm',
}

export const ShortBrandName = {
  [SiteCodes.JaycarAu]: SHORT_BRAND_NAME_JAYCAR,
  [SiteCodes.JaycarNz]: SHORT_BRAND_NAME_JAYCAR,
  [SiteCodes.RTM]: SHORT_BRAND_NAME_RTM,
  [BrandCode.Jaycar]: SHORT_BRAND_NAME_JAYCAR,
  [BrandCode.RTM]: SHORT_BRAND_NAME_RTM,
}

export const FullBrandName = {
  [SiteCodes.JaycarAu]: FULL_BRAND_NAME_JAYCAR,
  [SiteCodes.JaycarNz]: FULL_BRAND_NAME_JAYCAR,
  [SiteCodes.RTM]: FULL_BRAND_NAME_RTM,
  [BrandCode.Jaycar]: FULL_BRAND_NAME_JAYCAR,
  [BrandCode.RTM]: FULL_BRAND_NAME_RTM,
}
